<gl-password-constraints
  [target]="target"
  [password]="passwordToCheck"
  [title]="'auth.passwordStrength.title' | translate"
  [labels]="{
    length: 'auth.passwordStrength.type' | translate,
    upper: 'auth.passwordStrength.uppercase' | translate,
    digit: 'auth.passwordStrength.number' | translate,
    special: 'auth.passwordStrength.specialType' | translate
  }"
  [attr.position]="isMobile ? 'top' : null"
>
</gl-password-constraints>
